import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { UserModel } from '../../../../modules/auth/models/UserModel';
import { RootState } from '../../../../../setup';
import {
  KTSVG,
  maskPhoneNumber,
  LoadingGrid,
  formatDateMonth,
  formatPriceMejorado,
} from '../../../../../_mexablock/helpers';
import { TopUpBalanceModal } from '../../../../../_mexablock/partials/modals/balance/TopUpBalanceModal';
import { NewRechargeModal } from '../_modals/RechargeModal';
import { RechargeMultipleModal } from '../_modals/RechargeMultipleModal';
import { useGetAll } from '../hooks/RecargasHook';
import { TableList } from '../../../../../_mexablock/helpers/components/TableList';
import { Filter } from '../../../pagos/pagados/components/Filter';

const View: React.FC = () => {
  const user: UserModel = useSelector<RootState>(
    ({ auth }) => auth.user,
    shallowEqual
  ) as UserModel;
  const { saldo } = user;
  const [loadingView, setloadingView] = useState(true);
  const [idRow, setIdRow] = useState(0);
  const [visivilityModal, setVisivilityModal] = useState(false);
  const [visivilityTopUpModal, setVisivilityTopUpModal] = useState(false);
  const [visivilityRechargeModal, setVisivilityRechargeModal] = useState(false);
  const [titleModal, setTitleModal] = useState('');
  const [reloadGrid, setReloadGrid] = useState(Math.random() * 40);
  const [searchFilter, setSearchFilter] = useState<string>('');
  const [inputValue, setInputValue] = useState<string>('');
  const [initFilterValues, setInitFilterValues] = useState({
    init_date: '',
    end_date: '',
    search: '',
  });
  const { data, loadingRequest } = useGetAll(reloadGrid, initFilterValues);

  useEffect(() => {
    if (loadingRequest > 0) {
      setloadingView(false);
    }
  }, [loadingRequest]);

  // Disparar recarga cuando cambien los filtros
  useEffect(() => {
    if (initFilterValues.init_date || initFilterValues.end_date || initFilterValues.search) {
      setReloadGrid(Math.random() * 40);
    }
  }, [initFilterValues.init_date, initFilterValues.end_date, initFilterValues.search]);

  const addRegister = () => {
    setTitleModal('Recarga');
    setVisivilityModal(!visivilityModal);
  };
  const topUpMultipleBalance = () => {
    setVisivilityTopUpModal(!visivilityTopUpModal);
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    const regex = /^[0-9]*$/;

    if (regex.test(value)) {
      setInputValue(value);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      setSearchFilter(inputValue);
      setInitFilterValues((prev) => ({ ...prev, search: inputValue }));
    }
  };

  const handleFilter = (values: any) => {
    setInitFilterValues((prev) => ({
      ...prev,
      init_date: values.init_date,
      end_date: values.end_date,
    }));
  };

  const handleFilterClean = () => {
    setInitFilterValues({
      init_date: '',
      end_date: '',
      search: '',
    });
    setInputValue('');
    setSearchFilter('');
    setReloadGrid(Math.random() * 40);
  };

  const columns: any = [
    {
      id: 'fecha',
      name: <div className="fw-bolder text-muted me-5">Fecha</div>,
      selector: (row: any) => formatDateMonth(row.createdAt),

      sortable: true,
    },
    {
      id: 'source',
      name: <div className="fw-bolder text-muted me-5">Canal</div>,
      selector: (row: any) => row.source,
      sortable: true,
    },

    {
      id: 'phone',
      name: <div className="fw-bolder text-muted me-5">Número</div>,
      selector: (row: any) => maskPhoneNumber(row.phone),
      sortable: true,
    },
    {
      id: 'customer',
      name: <div className="fw-bolder text-muted me-5">Cliente</div>,
      selector: (row: any) => {
        const first = row?.customer?.first_name ?? '';
        const last = row?.customer?.father_last_name ?? '';
        const fullName = `${first} ${last}`.trim();

        return fullName || 'Sin nombre';
      },
      sortable: true,
    },
    {
      id: 'monto',
      name: <div className="fw-bolder text-muted me-5">Monto</div>,
      selector: (row: any) =>
        formatPriceMejorado(row.price_offer, 'es-MX', 'MXN'),
      sortable: true,
    },

    {
      id: 'usuario',
      name: <div className="fw-bolder text-muted me-5">Usuario</div>,
      selector: (row: any) =>
        row.source === 'Web'
          ? `${row.userCreate.first_name} ${row.userCreate.father_last_name}`
          : 'Usuario App',
      sortable: true,
    },
  ];

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="card-header border-0 pt-5">
              <div className="d-flex align-items-center gap-4">
                <Filter
                  initFilterValues={initFilterValues}
                  onCleanFilter={handleFilterClean}
                  onSearchFilter={handleFilter}
                />
                <div className="d-flex align-items-center position-relative me-4">
                  <span className="position-absolute ms-3" style={{ zIndex: 10 }}>
                    <i className="bi bi-search fs-4 text-muted"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control form-control-solid ps-9"
                    placeholder="Número"
                    maxLength={10}
                    value={inputValue}
                    onKeyDown={handleKeyDown}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div
                className="card-toolbar"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-trigger="hover"
                title="Nuevo registro"
              >
                <a
                  href="#/"
                  data-kt-menu="true"
                  className="btn btn-sm btn-light-primary"
                  // data-kt-menu-trigger="click"
                  // data-kt-menu-placement="bottom-end"
                  onClick={addRegister}
                >
                  <KTSVG
                    path="/media/icons/duotune/arrows/arr075.svg"
                    className="svg-icon-5 svg-icon-gray-500 me-1"
                  />
                  Nueva recarga
                </a>
              </div>
            </div>
            {loadingView ? (
              <LoadingGrid text="Cargando..."></LoadingGrid>
            ) : (
              <TableList data={data} columns={columns}></TableList>
            )}
          </div>
        </div>
      </div>
      <NewRechargeModal
        show={visivilityModal}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            // setLoadingGrid(true);
            setReloadGrid(Math.random() * 40);
          }
          setIdRow(0);
          setVisivilityModal(!visivilityModal);
        }}
      ></NewRechargeModal>
      <RechargeMultipleModal
        id_row={idRow}
        title={titleModal}
        show={visivilityTopUpModal}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
          }
          setIdRow(0);
          setVisivilityTopUpModal(!visivilityTopUpModal);
        }}
      ></RechargeMultipleModal>

      <TopUpBalanceModal
        show={visivilityRechargeModal}
        handleClose={(updateData: boolean) => {
          setVisivilityRechargeModal(!visivilityRechargeModal);
        }}
      />
    </>
  );
};

export { View };
